enum PlayerState {
    IDLE = "IDLE",
    WALKING = "WALKING",
    RUNNING = "RUNNING",
    WAVING = "WAVING",
    JUMPING = "JUMPING"
}

export default PlayerState;
